module.exports = __webpack_public_path__ + "img/thm_logo_ges.1ebc0817.png";